import { HttpStatusCode } from 'axios';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useHttp } from '@/composables';

export const useCartStore = defineStore('cart', () => {
  const cart = ref();
  const errors = ref();
  const isLoading = ref(true);

  // Working with the cart
  const loadCart = async () => {
    const response = await useHttp().get('/cart');

    if (response.statusCode === HttpStatusCode.Ok) {
      cart.value = response.data;
    }

    isLoading.value = false;
  };

  const updateCart = async (data) => {
    errors.value = null;

    const response = await useHttp().put('/cart', data);

    if (response.statusCode === HttpStatusCode.Ok) {
      cart.value = response.data;
    } else {
      errors.value = response.errors;
    }
  };

  // Working with cart items
  const addItem = async (data) => {
    isLoading.value = true; // set loading to true for CartModal skeleton

    const response = await useHttp().post('/cart/item', data);

    if (response.statusCode === HttpStatusCode.Ok) {
      cart.value = response.data;
    }

    isLoading.value = false;
  };

  const updateItem = async (data, orderId) => {
    const response = await useHttp().put(`/cart/item/${orderId}`, data);

    if (response.statusCode === HttpStatusCode.Ok) {
      cart.value = response.data;
    }
  };

  const removeItem = async (orderId) => {
    const response = await useHttp().delete(`/cart/item/${orderId}`);

    if (response.statusCode === HttpStatusCode.Ok) {
      cart.value.items.value = cart.value.items.filter(item => item.id !== orderId);
    }
  };

  return { cart, errors, isLoading, loadCart, updateCart, addItem, updateItem, removeItem };
});
